import axios from 'axios';
import { getCookie } from '../helpers/cookies';

const api = axios.create({
  baseURL: process.env.BFF_URL,
  withCredentials: process.env.NODE_ENV === 'production' ? true : false,
  withXSRFToken: true,
  timeout: process.env.NODE_ENV === 'production' ? 3000 : 9000,
  headers: {
    'Content-Type': 'multipart/form-data',
    Accept: '/',
    'Cache-Control': 'no-cache',
  },
});

api.interceptors.request.use(
  (request) => {
    const accessToken = getCookie('_TOKEN_BFF');

    if (accessToken) {
      request.headers.Authorization = `Bearer ${accessToken}`;
    }
    return request;
  },

  (err) => Promise.reject(err),
);

api.interceptors.response.use(
  (response) => response.data,
  (err) => {
    if (err.response === undefined) {
      const error = new Error('Não foi possível conectar ao servidor.');

      return Promise.reject(error.stack);
    }

    if (err.response.status === 401) {
      if (process.env.NODE_ENV !== 'development')
        window.location.assign(process.env.FRETEBRAS_LOGOUT_URL);
      return Promise.resolve();
    }

    return Promise.reject(err);
  },
);

export default api;
